import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import BasicDatePicker from '../../../containers/date_pickers/basic_date_picker';
import Chip from '@mui/material/Chip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { addDaysDate } from '../../../_utils/date_operations';

const MIN_DAYS_DELIVERY = 6;

const FIELDS = {
    btn: 'BTN',
    date: 'DATE'
}

const buildNextDateDelivery = () => {
    return addDaysDate(MIN_DAYS_DELIVERY, new Date());
}

const DateDeliveryPicker = (props) => {

    const [dateDelivery, setDateDelivery] = useState(buildNextDateDelivery());
    const [renderField, setRenderField] = useState(FIELDS.btn);
    const [dateDeliveryStr, setDateDeliveryStr] = useState('INMEDIATA');

    const setDateValue = (value) => {
        document.getElementById('order_date_delivery').value = value;
    }
    
    const setDate = (date) => {
        let dp = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        setDateValue(dp);
        setDateDeliveryStr(dp);
        setDateDelivery(date);
    }

    const setNullDateValue = () => {
        setDateValue(null);
        setDateDeliveryStr('INMEDIATA');
        setDateDelivery(buildNextDateDelivery());        
    }

    const changeCheckDelivery = (checked) => {
        if(checked){
            setRenderField(FIELDS.btn);
            setNullDateValue();
        } else {
            setRenderField(FIELDS.date);
            setDate(buildNextDateDelivery());
        }
    }

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                    <strong>Entrega: </strong>
                    <Chip style={{marginLeft: '10px', marginRight: '10px'}} size="small" label={dateDeliveryStr} color="warning" />
                </div>
            </Grid>
            <Grid item xs={12} md={12}>
                <input hidden id='order_date_delivery' defaultValue={null} />
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <FormControlLabel
                    control={
                        <Checkbox onChange={(e) => {
                            changeCheckDelivery(e.target.checked);
                            }} 
                            size="small"
                            defaultChecked 
                        />
                    } 
                    label="Entrega inmediata" 
                />
                {
                    renderField === FIELDS.btn ? (
                        <></>
                    ) : (
                        <BasicDatePicker
                            id='order_date_delivery_picker'
                            label='Fecha de entrega'
                            onChange={(v) => {setDate(v)}}
                            value={dateDelivery}
                            minDate={buildNextDateDelivery()}
                        />
                    )
                }
                </div>
            </Grid>
        </Grid>
    );

}

export default DateDeliveryPicker;